export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结果"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刷新状态"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有用链接"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["区块链："])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["进行中"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["失败"])}
}